import React from 'react';
import PropTypes from 'prop-types';
import { Column } from 'react-base-table';
import { Checkbox } from '@material-ui/core';
import { get } from 'lodash';

export const CheckboxCell = (props) => {
  const { cellData, rowData, column } = props;
  const { selectedRows, onSelect } = column;
  return (
    <Checkbox
      key={cellData.cellData}
      checked={!!selectedRows.includes(cellData)}
      onChange={() => onSelect({ ...rowData })}
    />
  );
};

CheckboxCell.propTypes = {
  cellData: PropTypes.number.isRequired,
  rowData: PropTypes.shape(PropTypes.shape).isRequired,
  column: PropTypes.shape({
    selectedRows: PropTypes.arrayOf(PropTypes.number),
    onSelect: PropTypes.func,
  }).isRequired,
};

export const CheckboxHeaderCell = (props) => {
  const { container, column } = props;
  const { selectedRows, onSelectAll } = column;
  const data = get(container, '_data', []);
  return (
    <Checkbox
      checked={data.length ? selectedRows.length === data.length : false}
      indeterminate={
        selectedRows.length > 0 && selectedRows.length !== data.length
      }
      onChange={(evt, checked) => onSelectAll(checked, data)}
    />
  );
};

CheckboxHeaderCell.propTypes = {
  container: PropTypes.element.isRequired,
  column: PropTypes.shape({
    selectedRows: PropTypes.arrayOf(PropTypes.number),
    onSelectAll: PropTypes.func,
  }).isRequired,
};

const CheckboxColumn = () => {};

CheckboxColumn.defaultProps = {
  cellRenderer: CheckboxCell,
  headerRenderer: CheckboxHeaderCell,
  selectedRows: [],
  onSelect: () => {},
  onSelectAll: () => {},
};

CheckboxColumn.propTypes = {
  ...Column.propTypes,
  selectedRows: PropTypes.arrayOf(PropTypes.number),
  onSelect: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
};

export default CheckboxColumn;
